// extracted by mini-css-extract-plugin
export default {"valueProgressIndicator":"ProgressBar__valueProgressIndicator___RmNYR","noProgressIndicator":"ProgressBar__noProgressIndicator___q0vp8"};